import "./kanban-board.scss"
import {DragDropContext,Droppable, Draggable, } from "react-beautiful-dnd"

import React, { SetStateAction, useEffect, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleArrowLeft, faEllipsis } from "@fortawesome/free-solid-svg-icons"
import api, { CRM_API_URI } from "api";
import { useParams } from "react-router-dom";
import { ColumnType } from "types"
import GetCursorPosition from "cursor-position"
import WorkflowOptions from "../view-workflow/workflow-options"
import WorkflowNew from "../view-workflow/workflow-new"
import { registerLoading } from "echarts"
import Ticket from "./ticket"
import moment from "moment"

interface props{
    wordBinId: number,
    deactivateWorkflow:any
}

function KanbanBoard({wordBinId,deactivateWorkflow}:props) {
  const [columnsFromBackend,setColumnsFromBackend]=useState<any[]>([]);
  const [itemsFromBackendLogicallyLinked,setItemsFromBackendLogicallyLinked]=useState<any[]>([]);
  const [name,setName]=useState<string>("");
  const [workflowId,setWorkflowId]=useState<number>();
  const [called,setCalled]=useState<boolean>(false);
  const [calledBadColumns,setCalledBadColumns]=useState<boolean>(false);
  const [calledColumnsColumns,setCalledColumns]=useState<boolean>(false);
  const [workFlow,setWorkFlow]=useState<any>();
  const [badColumns,setBadColumns]=useState<any[]>();
  const params: any = useParams();
  const [allowRender,SetAllowRender]=useState(false);
  const [count,setCount]=useState<number>(0);

  const  [columns, setColumns]=useState<ColumnType[]>([]);
  //Flow for getting data

  function delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
 }

  const getWorkflow= ()=>{
   
    setCalled(false);
    api.reactionLists.getWordflow(wordBinId).then(setWorkFlow);
    }  

    useEffect(()=>{
        if(workFlow && !called){
            getColumns();
            setCalled(true);
        }
    },[workFlow])

    const getColumns= ()=>{
            setName(workFlow.Description);
            setCalledBadColumns(false); 
            api.reactionLists.getWordflowDetails(workFlow.Id).then(setBadColumns);
    }

    useEffect(()=>{
    if(!calledBadColumns && badColumns){
        fixColumns();
        setCalledBadColumns(true);
    }
       
    },(badColumns))
   
    const fixColumns=()=>{
        
       if(badColumns){
        let NewColumns: any[]=[];
        badColumns.forEach(
           (item:any)=>{
               if(item.IsDeleted==false){
                   NewColumns.push(item);
               }
           } 
        )
        setCalledColumns(false);
        setColumnsFromBackend(NewColumns); 
       
       }   
    }

    useEffect(()=>{
        
        if(columnsFromBackend.length>0 && !calledColumnsColumns){
            columnsFromBackend.forEach((item:any) => {
                getItemsFromBackendLogicallyLinked(item.Id);
            });

            setCalledColumns(true);
        }
        
    },[columnsFromBackend])

   
    const getItemsFromBackendLogicallyLinked= (Id:any)=>{
        api.reactionLists.getWorkflowCips(Id,"2020/01/01","2023/01/01",params.projectId).then((result)=>fillArray(result));
    }
    
    const fillArray=(result:any)=>{
        
        let newArray=itemsFromBackendLogicallyLinked;
        result.forEach((item: any)=>{
            itemsFromBackendLogicallyLinked.push(item);
        })
       
        setItemsFromBackendLogicallyLinked(newArray);
        setColumns(columnsFromBackend);
    
        columns.forEach(col=>{
            itemsFromBackendLogicallyLinked.forEach(item=>{
               
                if(item.WorkflowGroupId==col.Id){
                  
                    if(col.Tickets==null)
                        col.Tickets=[]

                    let found=false;    
                    col.Tickets.forEach(t=>{
                        if(t.Id==item.Id)
                            found=true;
                    })

                    if(!found)
                    col.Tickets.push(item);
                }
            })
        })

        if(allowRender){
            let save=columns;
            setColumns([]);
            setColumns(save);   
         
        }else{
            SetAllowRender(true);
            getColumns();
        }
        columns.forEach((col)=>{
            if(col.Tickets==null)
                col.Tickets=[]
        })
        

    }
    //End data capture
    
    const onDragEnd=(result: any)=>{
        let removed:any =null;
        if(!result.destination) return;
        const {source, destination}= result;


        if(source.droppableId!== destination.droppableId){
            let cols=null;
            cols=columns;
            let sourceColumn:any=null;
            cols.forEach((column: any)=>{
                if(column.Id==source.droppableId)
                sourceColumn =column;
            })

            let  destColumn:any=null;
            destColumn=null;
            cols.forEach((column: any)=>{
                if(column.Id==destination.droppableId)
                destColumn =column;
            })
    
            let sourceItems:any=[];
            let destItems:any=[];
           sourceItems =[...sourceColumn.Tickets];
           destItems =[...destColumn.Tickets];


            [removed]=sourceItems.splice(source.index,1);
            destItems.splice(destination.index,0,removed);

            removed.WorkflowGroupId=destination.droppableId;

            api.reactionLists.updateClip(removed.Id,removed.WorkflowGroupId);
            //console.log(destItems);
            
             

            cols.forEach((col)=>{
                if(col.Id==source.droppableId){
                   col.Tickets=sourceItems;
                }
                

            })
            setColumns(cols);
            cols=columns;
            cols.forEach((col)=>{
                if(col.Id==destination.droppableId){
                    col.Tickets=destItems;
                 }
                

            })
            
            
            setColumns(cols);
            //console.log(columns);
            refesh();
            
        }else{
            let fromColumn:any =null;
            
            
             columns.forEach((column: any)=>{
                 if(column.Id==source.droppableId)
                    fromColumn =column;
             })
     
             
             
             if(fromColumn){
              
                 let copiedItems=[...fromColumn.Tickets];
                
                  [removed]=copiedItems.splice(source.index,1);
                  copiedItems.splice(destination.index,0,removed);
                 let cols=columns;
                 cols.forEach((col)=>{
                     if(col.Id==source.droppableId){
                        col.Tickets=copiedItems;
                     }
                 })
                 
                 setColumns(cols);
               
                
             setColumns(cols);  
             }
          
             
     
         }
        }
        const refesh=async ()=>{
            let save=columns;
            await delay(100);
            setColumns([]);
            setColumns(save);
        }
 


    useEffect(()=>{

        setItemsFromBackendLogicallyLinked([]);
        setWorkFlow(null);
        getWorkflow();
        //api.clip.getAll(params.projectId,moment().subtract(1,"years"),moment(),"7,8,9,10").then((r)=>console.log(r));
       console.log(params);
    },[])


    //Menu Options

    const [activeX,setActiveX]=useState(0);
    const [activeY,setActiveY]=useState(0);
    const [workflowOptionsActive, setWorkflowOptionsActive]=useState(false);
    const [fActiveX,setfActiveX]=useState(0);
    const [fActiveY,setfActiveY]=useState(0);
    const [activeWorkflowId,setActiveWorkflowId]=useState(0);

    document.addEventListener('mousemove', () => {
        const {x, y} = GetCursorPosition();
        setActiveX(x);
        setActiveY(y);
    })

    const activateOptions=(workFlowId:number)=>{
        setfActiveX(activeX);
        setfActiveY(activeY);
        setActiveWorkflowId(workFlowId);
        setWorkflowOptionsActive(true);
      }


    const deactivateOptions=()=>{
        if(workflowOptionsActive){
            setWorkflowOptionsActive(false);
        }
    }


    //New Workflow
    const [workflowNewActive, setWorkflowNewActive]=useState(false);

    const activeNewWorkflow=()=>{
        setCalled(false);
        setCalledColumns(false);
        setCalledBadColumns(false);
        setWorkflowNewActive(true);
    }

    
        
  

  return (
    <div className="fill-div">
      <div className="kanban-board" onClick={deactivateOptions}>
          <DragDropContext onDragEnd={result=>onDragEnd(result)}>
            
                {columns.map((column,index) =>(
                     <Droppable droppableId={column.Id.toString()} key={column.Id}>
                         {(provided,snapshot)=>{
                             return (
                                 
                                
                                 <div 
                                 {...provided.droppableProps}
                                 
                                 ref={provided.innerRef}
                                 className="columns"
                                style={{
                                    background: snapshot.isDraggingOver ? "lightblue" : "lightgrey",
                                    padding: 4,
                                    width: 250,
                                    minHeight: 300,
                                    maxHeight: 500,
                                   
                                }}
                                 >
                                 <div className="split-top">
                                     <div>
                                        {column.Description}
                                        {column.IsDefault && "(Default)"}
                                     </div>
                                       
                                         <FontAwesomeIcon onClick={()=>activateOptions(column.Id)} className="fa-el" icon={faEllipsis} />   
                                 </div>
                                
                                 
                                 {column.Tickets && column.Tickets.map((item ,Iindex)=>(
                                     item.WorkflowGroupId==column.Id? 
                                     (<Draggable key={item.Id} draggableId={item.Id.toString()} index={Iindex} >
                                        {(provided, snapshot)=>{
                                            return (
                                                
                                                <div 
                                                    ref={provided.innerRef}
                                                    {...provided.dragHandleProps}
                                                    {...provided.draggableProps}
                                                    key={item.Id}
                                                    style={{
                                                        userSelect: 'none',
                                                        padding: 16,
                                                        margin: '0 0 8px 0',
                                                        minHeight: '50px',
                                                        background: '#e0e0e0',
                                                        borderRadius: 5,
                                                       ...provided.draggableProps.style
                                                    }}
                                                >
                                                  <Ticket item={item}></Ticket>
                                                </div>  
                                                  
                                            )
                                            
                                        }}
                                 
                                </Draggable>):
                                     (<></>)
                                    

                                 ))}
                                 
                                 </div>
                                   
                             )
                             
                             }}
                           
                     </Droppable>  
                     
                ))}
                <div 
                    style={{
                        padding: 4,
                        width: 250,
                        minHeight: 500,
                    }}
                    onClick={activeNewWorkflow} 
                    className="new-columns">
                    <div className="workflow-heading">
                        <h3 > 
                            <i className="fal fa-plus">
                            </i>Add New Group
                        </h3>
                    </div>
                </div> 
                 
              
           </DragDropContext>   
      </div>
      {workFlow && workflowOptionsActive && <WorkflowOptions setActiveViewWorkflow={setWorkflowOptionsActive} setActiveX={fActiveX - 100} setActiveY={fActiveY-50} Id={activeWorkflowId} getWorkflow={getWorkflow} cols={columns} setCols={getColumns}/>}
      {workflowNewActive && <WorkflowNew setActiveWorkflowNew={setWorkflowNewActive} getWorkflow={getWorkflow} deactivateWorkflow={setColumns} columns={columns} getCol={setColumns} workFlow={workFlow} setItemsFromBackendLogicallyLinked={setItemsFromBackendLogicallyLinked} />}                       
      </div>
  )
}

export default KanbanBoard